/*
 * Injects the theme's USP strip into the Loop subscription widget.
 *
 * The Loop app renders (and RE-renders) the widget's DOM itself via
 * startLoopWidget(), which wipes anything we add. So we:
 *   1. clone the markup from <template data-loop-usp-template>,
 *   2. append it inside each [data-loop-widget-selling-plan-group] (the
 *      Subscribe & Save option),
 *   3. re-run under a MutationObserver so it comes back on every re-render,
 *   4. stay idempotent via the [data-loop-usp] guard.
 *
 * The selling-plan-group element only exists in the *real* widget (not the
 * skeleton loader), so the strip never flashes into the loading state.
 */
(function () {
  // Add a subtitle line directly under an option's title row (the header), once.
  function addSubtitle(option, text) {
    if (!option || !text) return;
    if (option.querySelector('[data-loop-usp-subtitle]')) return; // already added
    var header = option.querySelector('.loop-widget-purchase-option-header');
    if (!header) return;
    var el = document.createElement('div');
    el.className = 'loop-usp-subtitle';
    el.setAttribute('data-loop-usp-subtitle', '');
    el.textContent = text;
    header.insertAdjacentElement('afterend', el); // below the title/price row, above the frequency selector
  }

  function injectSubtitles() {
    var src = document.querySelector('[data-loop-usp-source]');
    if (!src) return;

    var onetimeText = src.getAttribute('data-onetime-subtitle') || '';
    if (onetimeText) {
      addSubtitle(document.querySelector('[data-loop-widget-onetime-purchase-option]'), onetimeText);
    }

    var subText = src.getAttribute('data-subscription-subtitle') || '';
    if (subText) {
      var groups = document.querySelectorAll('[data-loop-widget-selling-plan-group]');
      for (var i = 0; i < groups.length; i++) {
        addSubtitle(groups[i], subText);
      }
    }
  }

  function injectAll() {
    injectSubtitles();

    var tpl = document.querySelector('template[data-loop-usp-template]');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return;

    var groups = document.querySelectorAll('[data-loop-widget-selling-plan-group]');
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      if (group.querySelector('[data-loop-usp]')) continue; // already injected in this group

      var node = tpl.content.firstElementChild.cloneNode(true);
      group.appendChild(node);
    }
  }

  function start() {
    injectAll();

    var root = document.querySelector('product-info') || document.body;
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      // Coalesce bursts of Loop re-render mutations into one pass.
      (window.requestAnimationFrame || window.setTimeout)(function () {
        scheduled = false;
        injectAll();
      });
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
